import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import MobileNavModal from 'shared/mobile-nav-modal'
import StoreSearchButton from 'store/components/search-button'
import CartSummary from 'cart/components/cart-summary'
import classNames from 'classnames'
import {
  faqPath,
  findPath,
  helloBabyPath,
  indexPath,
  newRegistryPath,
  registryHomePath,
  storePath,
} from 'lib/urls'
import { initializePurchasingStore } from 'cart/lib'
import * as css from './global-nav.scss'
import {
  ACTIVE_NAV_SECTION_EVENT,
  HIDE_MOBILE_NAV_MODAL_EVENT,
} from 'shared/constants'
import Link from 'components/link'
import AccountMenu from './components/account-menu'
import { track, withContextualizedTracking } from 'lib/analytics'

@withContextualizedTracking((props) => {
  // use to track cart opened eventLocation
  const activeNavItem = props.activeNavItem
  var eventLocation = (function (eventLocation) {
    switch (eventLocation) {
      case 'Home':
        return track.EventLocation.HOME_PAGE
      case 'Registry':
        return track.EventLocation.REGISTRY
      case 'Guides':
        return track.EventLocation.GUIDE
      case 'Store':
        return track.EventLocation.STORE
      default:
        return track.EventLocation.NONE
    }
  })(activeNavItem)
  return { eventLocation: eventLocation }
})
class GlobalNav extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      activeNavItem: props.activeNavItem,
      sideNavVisible: false,
    }
    this.handleToggleNav = this.handleToggleNav.bind(this)
  }

  componentDidMount() {
    PubSub.subscribe(HIDE_MOBILE_NAV_MODAL_EVENT, () => {
      this.setState({ sideNavVisible: false })
    })
    PubSub.subscribe(ACTIVE_NAV_SECTION_EVENT, (event) => {
      this.setState({ activeNavItem: event })
    })
  }

  handleToggleNav() {
    this.setState({
      sideNavVisible: !this.state.sideNavVisible,
    })
  }

  render() {
    const {
      currentCart,
      currentUser,
      hideCartSummary,
      isRegistryGuestView,
      showMinimalView,
    } = this.props
    const { activeNavItem } = this.state

    return (
      <nav className={classNames(css.globalNav, css.withShadow)}>
        <div className="container">
          <div className={css.flexRow}>
            <ul className={classNames(css.farLeft)}>
              <ToggleNav onClick={this.handleToggleNav} />
              <SiteNavSection
                showMinimalView={isRegistryGuestView || showMinimalView}
                user={currentUser}
                activeNavItem={activeNavItem}
              />
            </ul>

            <div className={classNames(css.middle)}>
              <Logo />
            </div>

            <ul className={css.farRight}>
              <ActionsNavSection
                currentUser={currentUser}
                showMinimalView={isRegistryGuestView || showMinimalView}
                showSearch={activeNavItem === 'Guides'}
                cart={currentCart}
                isLoggedIn={currentUser ? true : false}
                hideCartSummary={hideCartSummary}
              />
            </ul>
            <MobileNavModal
              {...this.props}
              show={this.state.sideNavVisible}
              onHide={this.handleToggleNav}
            />
          </div>
        </div>
      </nav>
    )
  }
}

GlobalNav.propTypes = {
  activeNavItem: PropTypes.string,
  currentCart: PropTypes.object,
  currentUser: PropTypes.object,
  showMinimalView: PropTypes.bool,
  userCanViewRegistry: PropTypes.bool,
}

const SiteNavSection = ({ activeNavItem, showMinimalView, user }) => {
  return showMinimalView ? (
    <React.Fragment>
      <li className={classNames('hidden-xs', css.navLink)}>
        <a href={storePath}>Store</a>
      </li>
      <li className={classNames('hidden-xs', css.navLink)}>
        <a href={findPath}>Find Registry</a>
      </li>
    </React.Fragment>
  ) : (
    <React.Fragment>
      {user && user.currentRegistry && (
        <li
          className={classNames(
            'hidden-xs',
            css.navLink,
            css.homeLink,
            activeNavItem === 'Home' && css.homeActive
          )}
        >
          {<a href={registryHomePath}>Home</a>}
        </li>
      )}
      <li
        className={classNames(
          'hidden-xs',
          css.navLink,
          css.registryLink,
          activeNavItem === 'Registry' && css.registryActive
        )}
      >
        {
          <a
            href={
              user && user.currentRegistry
                ? `/${user.currentRegistry.urlSlug}`
                : indexPath
            }
          >
            Registry
          </a>
        }
      </li>
      <li
        className={classNames(
          'hidden-xs',
          css.navLink,
          css.storeLink,
          activeNavItem === 'Store' && css.storeActive
        )}
      >
        <a href={storePath}>Store</a>
      </li>
      <li
        className={classNames(
          'hidden-xs',
          css.navLink,
          css.guidesLink,
          activeNavItem === 'Guides' && css.guidesActive
        )}
      >
        <a href={helloBabyPath}>Guides</a>
      </li>
    </React.Fragment>
  )
}

SiteNavSection.propTypes = {
  activeNavItem: PropTypes.string,
  showMinimalView: PropTypes.bool,
  user: PropTypes.object,
}

const ActionsNavSection = ({
  cart,
  currentUser,
  hideCartSummary,
  showMinimalView,
  isLoggedIn,
  showSearch,
}) => {
  const reservations = cart.reservations.map((res) =>
    initializePurchasingStore(res)
  )
  return (
    <React.Fragment>
      <li className={classNames(css.navLink, 'hidden-xs')}>
        <Link url={faqPath} newWindow>
          Help
        </Link>
      </li>

      {!showMinimalView &&
        (isLoggedIn ? (
          <li className={classNames(css.navLink)}>
            <AccountMenu user={currentUser} />
          </li>
        ) : (
          // logged out
          <React.Fragment>
            <li className={classNames('hidden-xs', css.navLink)}>
              <a href={newRegistryPath}>Sign Up</a>
            </li>
            <li className={classNames('hidden-xs', css.navLink)}>
              <a href="javascript:PubSub.publish ('authModal.show')">Log In</a>
            </li>
          </React.Fragment>
        ))}

      {showSearch && (
        <li className={classNames(css.navIcnBtn, 'hidden-md', 'visible-xs')}>
          <StoreSearchButton />
        </li>
      )}

      <li className={css.navIcnBtn} style={{ position: 'relative' }}>
        <CartSummary
          cart={cart.cart}
          disableDropdown={hideCartSummary}
          registryUrlSlug={cart.registryUrlSlug}
          reservations={reservations}
        />
      </li>
    </React.Fragment>
  )
}

ActionsNavSection.propTypes = {
  cart: PropTypes.object,
  showMinimalView: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  showSearch: PropTypes.bool,
}

const Logo = ({ className }) => (
  <div className={classNames(css.logo, className)}>
    <a href={indexPath}>Babylist - Universal Baby Registry</a>
  </div>
)

Logo.propTypes = {
  className: PropTypes.string,
}

const ToggleNav = ({ onClick }) => (
  <button
    className={classNames(css.navToggle, 'hidden-md', 'visible-xs')}
    type="button"
    onClick={onClick}
  >
    <span className="sr-only">Toggle navigation</span>
    <span className={css.iconBar}></span>
    <span className={css.iconBar}></span>
    <span className={css.iconBar}></span>
  </button>
)

ToggleNav.propTypes = {
  onClick: PropTypes.func,
}

export {
  GlobalNav as default,
  SiteNavSection,
  ActionsNavSection,
  Logo,
  ToggleNav,
}
